import {_slideToggle, bodyLock, bodyLockToggle, bodyUnlock, removeClasses,} from "./functions.js";
import {initCheckboxFilter} from "../utilites/checkboxFilter.js";
import {initWeglotCustom} from "./weglot-integration.js";

// SubMenu Proccesing
const showSubMenu = function () {
	const menuItems = document.querySelectorAll(".menu__list > li");
	if (!menuItems.length) return;
	
	const isDesktop = () => window.innerWidth >= 1200;
	
	const closeAllMenus = function () {
		document.documentElement.classList.remove("sub-menu-open");
		document
			.querySelectorAll(".menu__list li.active")
			.forEach((element) => element.classList.remove("active"));
	};
	
	if (isDesktop()) {
		menuItems.forEach((item) => {
			const subMenu = item.querySelector(".menu__sub-menu, .drop-down");
			if (!subMenu) return;
			
			const anchor = item.querySelector("a[href='#']");
			if (anchor) {
				anchor.addEventListener("click", (e) => e.preventDefault());
			}
			
			let hideTimeout;
			
			const showMenu = () => {
				// закриваємо всі перед показом нового
				document
					.querySelectorAll(".menu__list li.active")
					.forEach((el) => el.classList.remove("active"));
				
				item.classList.add("active");
				
				if (!document.documentElement.classList.contains("sub-menu-open")) {
					document.documentElement.classList.add("sub-menu-open");
				}
				
				const dropdown = item.querySelector(".drop-down");
				if (dropdown) {
					const height = dropdown.offsetHeight;
					document.documentElement.style.setProperty("--sublist-height", `${height}px`);
				}
			};
			
			const hideMenu = () => {
				item.classList.remove("active");
				
				const anyActive = document.querySelector(".menu__list li.active");
				const isHoveringHeader = document
					.querySelector(".header")
					?.matches(":hover");
				
				if (!anyActive && !isHoveringHeader) {
					document.documentElement.classList.remove("sub-menu-open");
				}
			};
			
			const delayedHide = () => {
				hideTimeout = setTimeout(() => {
					const isHoveringItem = item.matches(":hover");
					const isHoveringSubmenu = subMenu.matches(":hover");
					const isHoveringHeader = document
						.querySelector(".header")
						?.matches(":hover");
					
					if (!isHoveringItem && !isHoveringSubmenu && !isHoveringHeader) {
						hideMenu();
					}
				}, 150);
			};
			
			item.addEventListener("mouseenter", () => {
				clearTimeout(hideTimeout);
				showMenu();
			});
			
			item.addEventListener("mouseleave", delayedHide);
			subMenu.addEventListener("mouseenter", () => clearTimeout(hideTimeout));
			subMenu.addEventListener("mouseleave", delayedHide);
		});
		
		return;
	}
	
	// Click logic for mobile only
	document.addEventListener("click", (e) => {
		const target = e.target;
		const sublistItem = target.closest(".menu__list") ? target.closest("li") : null;
		const isSubmenuOpen = document.documentElement.classList.contains("sub-menu-open");
		
		if (target.closest(".sub-menu__button")) {
			closeAllMenus();
			return;
		}
		
		if (target.classList.contains("icon-menu")) return;
		
		if (!sublistItem) {
			if (isSubmenuOpen) closeAllMenus();
			return;
		}
		
		const currentSublist = sublistItem.querySelector(".menu__sub-menu") || sublistItem.querySelector(".sub-menu") || sublistItem.querySelector(".drop-down");
		if (!currentSublist) return;
		
		const isSubmenuButton = target.classList.contains("sub-menu__button") || target.closest(".sub-menu__button");
		const isActive = sublistItem.classList.contains("active");
		const isTouch = document.documentElement.classList.contains("touch");
		const isSubmenu = target.closest(".sub-menu") || target.closest(".menu__sub-menu");
		const shouldToggleSubmenu = window.innerWidth > 768 || !currentSublist.classList.contains("drop-down");
		
		// Allow clicks inside submenu content on mobile, but handle back button
		if (isTouch && isSubmenu) {
			// If it's the back button, allow it to close the menu
			if (target.closest(".sub-menu__button")) {
				// Don't return early, let it proceed to close the menu
			} else {
				// For other clicks inside submenu, don't close the menu
				return;
			}
		}
		if (!isTouch && isSubmenu) return;
		
		closeAllMenus();
		
		if (isSubmenuButton || (isSubmenuOpen && isActive)) {
			sublistItem.classList.toggle("active", !isActive);
			document.documentElement.classList.toggle("sub-menu-open", !isSubmenuOpen);
			if (!isDesktop()) {
				bodyLockToggle();
			}
		} else if (shouldToggleSubmenu && !isSubmenu) {
			sublistItem.classList.add("active");
			document.documentElement.classList.add("sub-menu-open");
			
			if (!isDesktop() && !sublistItem.classList.contains("has-dropdown")) {
				setTimeout(() => {
					bodyLock();
				}, 200);
			}
			
			if (sublistItem.classList.contains("has-dropdown")) {
				let currentSubListHeight = sublistItem?.querySelector(".drop-down").offsetHeight;
				document.documentElement.style.setProperty("--sublist-height", `${currentSubListHeight}px`);
			}
		}
	});
};

function dropdownMenuInit() {
	const dropDownMenus = document.querySelectorAll(".drop-down");
	
	if (!dropDownMenus.length) return;
	dropDownMenus.forEach((menu) => {
		const parent = menu.closest("li") || menu.parentElement;
		parent.classList.add("has-dropdown");
	});
}

//Search Show/Hide
const showSearchResults = function () {
	const searches = document.querySelectorAll(".search-form__input .input");
	
	if (searches.length) {
		searches.forEach((search) => {
			search.addEventListener("input", function () {
				const searchForm = search.closest(".search-form");
				
				if (search.value === "") {
					searchForm.classList.remove("active");
				} else if (!searchForm.classList.contains("active")) {
					searchForm.classList.add("active");
					
					// Добавляем обработчик клика на document
					const handleOutsideClick = (e) => {
						// Если клик не внутри текущей search-form
						if (!searchForm.contains(e.target)) {
							searchForm.classList.remove("active");
							document.removeEventListener("click", handleOutsideClick); // Убираем прослушку
						}
					};
					
					// Добавляем прослушку клика
					document.addEventListener("click", handleOutsideClick);
				}
			});
		});
	}
};

const showSearchOnMobile = function () {
	const searchForms = document.querySelectorAll(".search-form");
	
	if (searchForms.length && window.innerWidth < 650) {
		const hideAllSearch = function () {
			const searches = document.querySelectorAll(".search-form.show-search-field");
			removeClasses(searches, "show-search-field");
			removeClasses(searches, "active");
		};
		window.addEventListener("click", function (e) {
			let target = e.target;
			let currentSearch = target.closest(".search-form");
			
			if (currentSearch) {
				if (!currentSearch.classList.contains("show-search-field")) {
					currentSearch.classList.add("show-search-field");
					
					setTimeout(() => {
						currentSearch.querySelector(".search-form__input input").focus();
					}, 400);
				}
				if (target.closest(".search-form__icon")) {
				}
			} else {
				hideAllSearch();
			}
		});
	}
};

// Show/Hide Mini Cart
const toggleDropdown = function () {
	document.addEventListener("click", function (e) {
		const target = e.target;
		const dropdown = target.closest("[data-dropdown]");
		if (e.target.closest('.body-mini-cart__remove')) return;
		if (dropdown) {
			const button = target.closest("[data-dropdown-toggle]");
			if (button) {
				document
					.querySelectorAll("[data-dropdown].active")
					.forEach((activeDropdown) => {
						if (activeDropdown !== dropdown) {
							activeDropdown.classList.remove("active");
						}
					});
				
				dropdown.classList.toggle("active");
			}
		} else {
			document
				.querySelectorAll("[data-dropdown].active")
				.forEach((activeDropdown) => {
					activeDropdown.classList.remove("active");
				});
		}
	});
};

const showLangSwitcher = function () {
	const langSwitchers = document.querySelectorAll(".language-switcher");
	
	if (langSwitchers.length) {
		document.addEventListener("click", function (e) {
			let target = e.target;
			let currentLangSwitcher = target.closest(".language-switcher");
			
			if (currentLangSwitcher) {
				if (target.closest(".language-switcher__title")) {
					if (!currentLangSwitcher.classList.contains("active")) {
						currentLangSwitcher.classList.add("active");
					} else {
						currentLangSwitcher.classList.remove("active");
					}
				}
			} else {
				langSwitchers.forEach((el) => {
					el.classList.remove("active");
				});
			}
		});
	}
};

//show more courses
const showMoreActions = function () {
	const showMoreButtons = document.querySelectorAll("[data-show-more-button]");
	
	setTimeout(() => {
		if (showMoreButtons.length) {
			showMoreButtons.forEach((showMoreButton) => {
				if (!showMoreButton.closest("[data-show-more]")) return;
				showMoreButton.addEventListener("click", function (e) {
					const activeTabsBody = showMoreButton.closest("[data-show-more]");
					
					if (!activeTabsBody) return;
					
					const currentHiddenInfo = activeTabsBody.querySelector("[data-show-more-content]");
					
					if (!currentHiddenInfo) return;
					
					_slideToggle(currentHiddenInfo);
					showMoreButton.classList.toggle("active");
				});
			});
		}
	}, 2000);
};

// Show/Hide Training Search
const showTrainingSearch = function () {
	const searchButtons = document.querySelectorAll(".tabs-training__search-courses");
	const searchContainers = document.querySelectorAll(".tabs-training__search");
	
	if (searchButtons.length && searchContainers.length) {
		// Initially hide all search containers
		searchContainers.forEach((container) => {
			container.style.display = "none";
			container.style.opacity = "0";
			container.style.transition = "opacity 0.3s ease";
		});
		
		searchButtons.forEach((button) => {
			button.addEventListener("click", function () {
				const tabsContent = button.closest(".tabs-training__content");
				if (!tabsContent) return;
				
				const searchContainer = tabsContent.querySelector(".tabs-training__search");
				if (!searchContainer) return;
				
				if (searchContainer.style.display === "none" || !searchContainer.style.display) {
					// Show the search container with smooth transition
					searchContainer.style.display = "block";
					// Use setTimeout to ensure the display change takes effect before changing opacity
					setTimeout(() => {
						searchContainer.style.opacity = "1";
					}, 10);
					
					// Focus on the search input
					const searchInput = searchContainer.querySelector("input");
					if (searchInput) {
						setTimeout(() => {
							searchInput.focus();
						}, 300);
					}
				} else {
					// Hide the search container with smooth transition
					searchContainer.style.opacity = "0";
					setTimeout(() => {
						searchContainer.style.display = "none";
					}, 300);
				}
			});
		});
		
		// Close search when clicking outside
		document.addEventListener("click", function (e) {
			if (!e.target.closest(".tabs-training__search") && !e.target.closest(".tabs-training__search-courses")) {
				searchContainers.forEach((container) => {
					container.style.opacity = "0";
					setTimeout(() => {
						container.style.display = "none";
					}, 300);
				});
			}
		});
	}
};

const swapAnimationInit = function () {
	const swapAnimation = document.querySelector(".swap-animation");
	if (!swapAnimation) return; // Check if the element exists
	
	const inner = swapAnimation.querySelector(".swap-animation__inner");
	const values = Array.from(inner.querySelectorAll(".swap-animation__value"));
	
	// Get gap and delay from data attributes
	const gap = parseInt(swapAnimation.dataset.gap) || 4; // Default gap is 4px
	const delay = parseInt(swapAnimation.dataset.delay) || 2000; // Default delay is 2000ms
	
	// Calculate maximum height and width
	const maxHeight = Math.max(...values.map((el) => el.offsetHeight));
	const maxWidth = Math.max(...values.map((el) => el.offsetWidth));
	
	// Set CSS variables
	swapAnimation.style.setProperty("--max-height", `${maxHeight}px`);
	swapAnimation.style.setProperty("--max-width", `${maxWidth}px`);
	swapAnimation.style.setProperty("--gap", `${gap}px`);
	
	// Clone the first element and append it to the end
	const clone = values[0].cloneNode(true);
	inner.appendChild(clone);
	
	let currentIndex = 0;
	
	const animate = () => {
		currentIndex++;
		swapAnimation.classList.remove("no-transition"); // Remove the class if it exists
		swapAnimation.style.setProperty("--translate-y", `-${(maxHeight + gap) * currentIndex}px`);
		
		// Check if the last (cloned) element is reached
		if (currentIndex === values.length) {
			setTimeout(() => {
				swapAnimation.classList.add("no-transition"); // Add the class to disable animation
				swapAnimation.style.setProperty("--translate-y", "0");
				currentIndex = 0;
			}, 500); // Match the animation duration
		}
	};
	
	setInterval(animate, delay);
};

const showFilters = function () {
	const filterOpenButton = document.querySelector("[data-filter-open]");
	const filterCloseButton = document.querySelector("[data-filter-close]");
	const filterBody = document.querySelector("[data-filter-body]");
	const isMobile = window.innerWidth < 991;
	
	if (!isMobile || !filterOpenButton || !filterCloseButton || !filterBody) return;
	
	document.documentElement.style.setProperty("--filter-body-height", `${filterBody.offsetHeight}px`);
	
	filterOpenButton.addEventListener("click", () => {
		document.documentElement.classList.add("filter-open");
		if (typeof bodyLock === "function") bodyLock();
	});
	
	filterCloseButton.addEventListener("click", () => {
		document.documentElement.classList.remove("filter-open");
		if (typeof bodyUnlock === "function") bodyUnlock();
	});
};

const playVideoPlayer = function () {
	// Находим все контейнеры с видео
	const videoContainers = document.querySelectorAll("[data-video]");
	
	if (videoContainers.length) {
		videoContainers.forEach((container) => {
			const video = container.querySelector("video");
			const button = container.querySelector("[data-video-button]");
			
			if (!video || !button) return;
			
			// Обработчик нажатия на кнопку
			button.addEventListener("click", () => {
				if (!container.classList.contains("video-is-playing")) {
					// Если видео не воспроизводится
					container.classList.add("video-is-playing");
					video.play();
				} else {
					// Если видео воспроизводится
					container.classList.remove("video-is-playing");
					video.pause();
					// video.currentTime = 0; // Сбрасываем видео на начало
				}
			});
		});
	}
};

function initCopyButtons() {
	// Find all buttons with the attribute data-copy-button
	const copyButtons = document.querySelectorAll("[data-copy-button]");
	
	if (copyButtons.length > 0) {
		copyButtons.forEach((button) => {
			button.addEventListener("click", () => {
				const contentToCopy = button.hasAttribute("data-copy-content") ? button.getAttribute("data-copy-content") // Copy from data-copy-content
					: window.location.href; // Otherwise, copy current URL
				
				// Add the 'copied' class
				button.classList.add("copied");
				
				// Remove the 'copied' class after 3 seconds
				setTimeout(() => {
					button.classList.remove("copied");
				}, 2000);
				
				// Check if the Clipboard API is supported
				if (navigator.clipboard && navigator.clipboard.writeText) {
					// Copy the current URL to the clipboard
					
					navigator.clipboard
						.writeText(contentToCopy)
						.then(() => {
							// console.log('URL copied to clipboard:', currentUrl);
						})
						.catch((err) => {
							console.error("Failed to copy the URL:", err);
						});
				} else {
					console.warn("Clipboard API is not supported in this browser.");
				}
			});
		});
	}
}

//show active section for single course page
function initializeNavigationObserver() {
	const navItems = document.querySelectorAll(".single-course__item-navigation a");
	if (navItems.length === 0) return;
	
	const sections = Array.from(navItems).map((link) => {
		const id = link.getAttribute("href").substring(1);
		const section = document.getElementById(id);
		return {
			id,
			section,
			link,
		};
	});
	
	const observerOptions = {
		root: null,
		rootMargin: "0px",
		threshold: 0.5,
	};
	
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const activeSection = sections.find((sec) => sec.section === entry.target);
				if (activeSection) {
					navItems.forEach((item) => item.parentElement.classList.remove("active"));
					activeSection.link.parentElement.classList.add("active");
				}
			}
		});
	}, observerOptions);
	
	sections.forEach(({section}) => {
		if (section) {
			observer.observe(section);
		}
	});
}

// Interactive Mega Menu
const initInteractiveMegaMenu = function () {
	const interactiveMenus = document.querySelectorAll("[data-interactive-menu]");
	
	if (!interactiveMenus.length) return;
	
	interactiveMenus.forEach((menu) => {
		const categoryItems = menu.querySelectorAll(".sub-menu__category-item");
		const categoryContents = menu.querySelectorAll(".sub-menu__category-content");
		
		if (!categoryItems.length || !categoryContents.length) return;
		
		// Function to switch category content
		const switchCategory = (targetIndex) => {
			// Remove active class from all interactive category items (exclude .last)
			categoryItems.forEach((item) => {
				if (!item.classList.contains("last")) {
					item.classList.remove("active");
				}
			});
			
			// Remove active class from all category contents
			categoryContents.forEach((content) => content.classList.remove("active"));
			
			// Add active class to target category item
			const targetItem = menu.querySelector(`[data-category-index="${targetIndex}"]`);
			if (targetItem) {
				targetItem.classList.add("active");
			}
			
			// Add active class to target category content
			const targetContent = menu.querySelector(`[data-category-content="${targetIndex}"]`);
			if (targetContent) {
				targetContent.classList.add("active");
			}
		};
		
		// Add event listeners for category items (exclude the "All courses" item with .last class)
		categoryItems.forEach((item) => {
			// Skip the "All courses" item which has the "last" class
			if (item.classList.contains("last")) {
				return;
			}
			
			const categoryIndex = item.getAttribute("data-category-index");
			
			// Desktop: hover behavior
			if (window.innerWidth >= 1200) {
				item.addEventListener("mouseenter", () => {
					switchCategory(categoryIndex);
				});
			}
			
			// Mobile/Touch: click behavior
			item.addEventListener("click", (e) => {
				e.preventDefault();
				switchCategory(categoryIndex);
			});
		});
		
		// Handle window resize to switch between hover and click behavior
		let resizeTimeout;
		window.addEventListener("resize", () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				// Re-initialize event listeners based on new screen size
				// This is handled by the existing logic above
			}, 250);
		});
	});
};

//Swap Animation
swapAnimationInit();
window.addEventListener("load", function () {
	setTimeout(function () {
		// Show/Hide filters
		showFilters();
		
		initCheckboxFilter();
		
		showMoreActions();
		
		playVideoPlayer();
		
		toggleDropdown();
		
		showLangSwitcher();
		
		showSearchResults();
		
		showSearchOnMobile();
		
		dropdownMenuInit();
		showSubMenu();
		
		// Initialize interactive mega menu
		initInteractiveMegaMenu();
		
		initCopyButtons();
		
		initializeNavigationObserver();
		
		// Initialize training search functionality
		showTrainingSearch();
		
		// Initialize Weglot custom functionality
		initWeglotCustom();
	}, 0);
});